import React from "react"
import { CSVLink } from "react-csv"

import downloadStyles from './csvDownload.module.scss'

const CsvDownload = ({tableData, fileName, ignores=[]}) => {

    // set up table data //
    var tableDataParsed = []
    console.log(tableData)
    console.log(typeof tableData)
    if (ignores.length > 0) {
        tableDataParsed = tableData.map((record) => {
            // create a copy of record so ignores do not mess up displayed data //
            // go through record and remove any keys that are in ignores //
            var parsedRec = JSON.parse(JSON.stringify(record))
            ignores.forEach((ignore) => {
                delete parsedRec[ignore]
            })

            return parsedRec

        });
    } else {
        tableDataParsed = tableData
    }

    const downloadEventTracking = (e) => {
        if (typeof window !== 'undefined') {
            window.gtag(
                'event',
                'dataDownload',
                {
                    'fileName' : fileName,
                    'fileType' : 'free'
                }
            )
        } else {
            return null
        }
    }

    return (

        <CSVLink
            className={downloadStyles.csvLink}
            data={tableDataParsed}
            filename={fileName}
        >
            <div className={downloadStyles.downloadButton} onClick={downloadEventTracking}>
                Download <span className={downloadStyles.iconSpan}>{`\u2398`}</span>
            </div>
        </CSVLink>

    )
}

export default CsvDownload